var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.show)?_c('div',{staticClass:"menu_style",class:{ phone_menu_style: _vm.isPhone },style:({ top: _vm.y + 'px', left: _vm.x + 'px' })},[_c('ul',[_c('li',{on:{"click":function($event){$event.stopPropagation();return (function () {
          _vm.$emit('open');
        }).apply(null, arguments)}}},[_vm._v(" 打开 ")]),_c('li',{on:{"click":function($event){$event.stopPropagation();return (function () {
          _vm.$emit('report');
        }).apply(null, arguments)}}},[_vm._v(" 举报 ")]),_c('li',{on:{"click":function($event){$event.stopPropagation();return (function () {
          _vm.$emit('clo');
        }).apply(null, arguments)}}},[_vm._v(" 关闭 ")])])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }